<template>
  <div>
    <div class="card card__module" :class="userCourse.status" v-loading="isLoading">
      <a class="module__link" :href="userCourse.url"  v-on:click.capture="isLoading = true">
        <header class="card__header">
          <div class="module__heading">{{ userCourse.title }}</div>
        </header>
        <div class="card__media__container">
          <div class="card__media">
            <img v-if="courseInfo['bigImage']" :src="courseInfo['bigImage']">
            <img v-else :src="fallbackJpg">
          </div>
        </div>
        <div class="progress" role="progressbar" tabindex="0" :aria-valuenow="percentComplete" aria-valuemin="0" :aria-valuetext="percentComplete + ' percent'" aria-valuemax="100">
          <div class="progress-meter" v-bind:style="{width: percentComplete + '%'}"></div>
        </div>
        <div v-if="courseInfo.isFullLineSummary" class="progress-text">{{ $t('trainingModuleInProgressFullLinePercent') }}</div>
        <div v-else-if="userCourse.status == 'inProgress'" class="progress-text">{{ percentComplete }}{{ $t('trainingPercent') }}</div>
        <div v-else class="progress-text">{{ $t('trainingModuleFailed') }}</div>
        <div class="card__actions text-align-center">
          <span v-if="courseInfo.isFullLineSummary" class="card__link-emphasized">{{ $t('trainingModuleInProgressFullLineCardCta') }}</span>
          <span v-else-if="userCourse.status == 'inProgress'" class="card__link-emphasized">{{ $t('trainingModuleInProgressCardCta') }}</span>
          <span v-else class="card__link-emphasized">{{ $t('trainingModuleFailedCardCta') }}</span>
        </div>
      </a>
    </div>
    <div class="module__started-days-label">{{ $t('trainingStarted') }}</div>
    <div v-if="!userCourse.started" class="module__started-days-text">{{ $t('trainingStartedToday') }}</div>
    <div v-else class="module__started-days-text">{{ userCourse.started }} ago</div>
  </div>
</template>

<script>
  import training from '@/components/training';
  import fallbackJpg from '@/assets/images/fallbackSquare.jpg';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import fullLineRibbon from '@/assets/images/full-line-ribbon.svg';
  import loadingStateReset from '@/mixins/loadingStateReset';

  export default {
    name : 'TrainingInProgressCard',
    mixins: [loadingStateReset],
    data() {
      return {
        fallbackJpg,
        isLoading : false,
          fullLineRibbon,
      }
    },
    props : {
      userCourse : {},  // Info specific to an in progress course (user assigned course).
      courseInfo : {},  // Info availabe about the course in general.
    },
    computed : {
      percentComplete : function() {
        if (this.userCourse.status == 'failed') {
          return 0;
        }

        return this.userCourse.percent;
      },
    },
  };
</script>

<style lang="scss" scoped>

  .card__module {

    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    color: #303133;
    .card__media__container{
      padding: 0 20px;
    }
    .card__actions{
      margin-bottom: 20px;
    }

    .card__media{
      padding-top: 80%;
      img{
        object-fit: contain;
        object-position: 0 108%;
      }

    }
    .card__link-emphasized::after{
      content: "\E6DE";
      font-family: element-icons !important;
      display: inline-block;
      transform: rotate(180deg);
      top: -1px;
      margin-left: 3px;
      position: relative;
    }
    .progress{
      position: relative;
      top: -10px;
      width: 105%;
    }

    &.failed{
      border: 1px solid #D31F25;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);

      .progress-text{
        color: #D31F25;
        font-weight: bolder;
      }
    }
  }
  .module {


    &__link {
      overflow: hidden;
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      padding-top: 63px;
      text-decoration: none;
    }

    &__heading {
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      color: #000000;
      padding: 20px 20px 0;
    }

    &__started-days-label {
      font-size: 11px;
      line-height: 15px;
      text-align: right;
      text-transform: uppercase;
    }

    &__started-days-text {
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      text-align: right;
      text-transform: uppercase;
    }
  }

  .card__module {

    .card__actions {
      border-top: 0;
    }

    .progress {
      background: #DDDDDD;
    }

    .progress-meter {
      margin-top: 5px;
      background: #D31F25;
      height: 25px;
      transform: skew(-26deg);
      left: -6px;
      position: relative;
    }

    .progress-text {
      margin-top: 2px;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      text-transform: uppercase;
      color: #000000;
    }

  }
  .el-card__body{
    padding: 0 !important;
  }

</style>
